import { useAppStateSelector, useSelectedFiltersCount, pick } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks"

import SortBy from "./SortBy"
import ToolbarFilters from "./ToolbarFilters"
import Sidebar from "./Sidebar"

import { fetchCategoryTotal } from "../helpers"

export default function Toolbar() {
    const { response } = useAppStateSelector(state => pick(state, "response"));
    const selectedFiltersCount = useSelectedFiltersCount();
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const sidebarToggleRef = useRef(null);

    useEffect(async () => {
        const countEl = document.querySelector('.collection-hero__product-count > span');
        if(countEl && response.products?.categoryId) {
            const total = await fetchCategoryTotal(response.products?.categoryId);
            countEl.textContent = total ? `${total} item${total > 1 ? 's' : ''}` : '';
        }
    }, [])

    const closeSidebar = () => {
        setSidebarOpen(false);
        sidebarToggleRef.current?.focus(); /* avoid aria warnings */
    }

    return (
        <>
            <Sidebar 
                sidebarOpen={sidebarOpen}
                closeSidebar={closeSidebar}
            />

            <div class="ns-toolbar ns-w-100">
                <div class="ns-toolbar-inner ns-relative ns-flex ns-align-center ns-justify-between ns-page-width">
                    <div class='ns-flex ns-items-center'>
                        <button 
                            class="ns-sidebar-toggle ns-flex ns-flex-nowrap ns-align-center ns-lg-hidden"
                            type="button"
                            aria-controls="ns-sidebar"
                            aria-expanded={sidebarOpen}
                            ref={sidebarToggleRef}
                            onClick={() => setSidebarOpen(prevSidebarOpen => !prevSidebarOpen)}
                        >
                            <span class="ns-folio-reg">Filters {selectedFiltersCount > 0 ? `(${selectedFiltersCount})` : ''}</span>
                            <span class="ns-toggle-icon ns-relative" role="presentation" aria-hidden="true" />
                        </button>

                        <ToolbarFilters />
                    </div>

                    <SortBy />
                </div>
            </div>
        </>
    )
}
